import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useRegion } from '../../context/RegionContext';

const ProductCard = ({ product, onQuickView }) => {
const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const { addToCart } = useCart();
  const { formatPrice } = useRegion();

  const handleAddToCart = (e) => {
    e.preventDefault();
    addToCart(product);
  };

  return (
    
   <div 
  className="group relative bg-white rounded-xl overflow-hidden shadow-soft card-hover animate-fade-in cursor-pointer"
  onClick={() => navigate(`/product/${product.id}`)}  // ← ADD THIS
  onMouseEnter={() => setIsHovered(true)}
  onMouseLeave={() => setIsHovered(false)}
>
      {/* Image Container */}
      <div className="relative aspect-square overflow-hidden bg-gray-100">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        
        {/* Overlay Actions */}
        <div className={`absolute inset-0 bg-black/40 transition-opacity duration-300 ${
          isHovered ? 'opacity-100' : 'opacity-0'
        }`}>
        </div>

        {/* Badges */}
        <div className="absolute top-3 left-3 flex flex-col gap-2">
          {!product.inStock && (
            <span className="px-3 py-1 bg-red-500 text-white text-xs font-bold rounded-full">
              Out of Stock
            </span>
          )}
        </div>
      </div>

      {/* Product Info */}
      <div className="p-4 mx-2">
        <div className="h-2 mb-11">
           <h3 className="text-lg font-semibold text-dark-800 mb-1 line-clamp-2 group-hover:text-primary-700 transition-colors duration-300">
          {product.name}
         </h3>
        </div>
        <div>
          <div className="flex items-center justify-between gap-2">
          <div >
            <p className="col-span-1 text-1xl md:text-2xl font-medium font-bold text-primary-700">
              {formatPrice(product.priceCAD)}
            </p>
          </div>
          <span className="text-xs px-2 py-1 bg-gray-100 text-gray-700 rounded-full font-medium">
            {product.material}
          </span>
        </div>
        </div>
        <div className="flex flex-col items-center gap-2 my-2">
            <button
           onClick={(e) => {
            e.stopPropagation();
            navigate(`/product/${product.id}`);
            }}
             className=" px-4 py-2 w-full border-2 border-primary-600 text-primary-600 rounded-lg hover:bg-primary-600 hover:scale-105 hover:text-white transition-all duration-300 text-sm font-medium"
            >
            View Details
          </button>
          
          <button
            onClick={handleAddToCart}
            disabled={!product.inStock}
            className=" px-4 py-3 w-full bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none text-sm font-medium"
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
